<template>
  <el-popover
    placement="bottom-start"
    width="400"
    trigger="click">
    <ul v-if="iconList">
      <li :class="{'is-active':selectItem===item}" @click="clickLi(item)" v-for="item in iconList">
        <i :class="item"></i>
      </li>
    </ul>
    <div class="selectBox" slot="reference">
      <i :class="selectItem" ></i>
    </div>
  </el-popover>

</template>

<script>
  import $icon from "../../../static/plugin/element-icon"
  export default {
    name: 'icon-box',
    props: ['value'],
    data () {
      return {
        iconList:$icon.iconList,
        selectItem:""
      }
    },
    watch:{
      value(n){
        this.selectItem = n ;
      }
    },
    mixins: [tableBase],
    methods: {
      clickLi(item){
        this.selectItem = item;
        this.$emit('input', item);
      }
    },
    mounted () {
      this.selectItem = this.value;
    }
  }
</script>

<style lang="less" scoped>

  ul:not(.timeline) {
    margin: 10px 0;
    padding: 0 0 0 20px;
    font-size: 14px;
    color: #5e6d82;
    line-height: 2em;
  }
  ul{
    overflow: hidden;
    list-style: none;
    padding: 0!important;
    border: 1px solid #eaeefb;
    border-radius: 4px;
    height:300px;
    overflow-y: scroll;
    li{
      float: left;
      width: 16.66%;
      text-align: center;
      height: 30px;
      line-height: 30px;
      color: #666;
      font-size: 13px;
      border-right: 1px solid #eee;
      border-bottom: 1px solid #eee;
      margin-right: -1px;
      margin-bottom: -1px;
      &:hover{
        background-color: #0071ef;
        color: white;
      }
      &.is-active{
        background-color: #0071ef;
        color: white;
      }
    }
  }
  .selectBox{
    width: 40px;
    text-align: center;
    border: 1px solid #e6e6e6;

    i{
      margin: 6px;
      font-size: 20px;
    }
  }
</style>
